module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-database-2.f8a932a2.svg";